var map = {
	"./10C.png": 4385,
	"./10D.png": 1294,
	"./10H.png": 9202,
	"./10S.png": 6273,
	"./2C.png": 6614,
	"./2D.png": 5241,
	"./2H.png": 2101,
	"./2S.png": 9526,
	"./3C.png": 7081,
	"./3D.png": 7110,
	"./3H.png": 5994,
	"./3S.png": 2825,
	"./4C.png": 5300,
	"./4D.png": 107,
	"./4H.png": 3127,
	"./4S.png": 148,
	"./5C.png": 6543,
	"./5D.png": 4320,
	"./5H.png": 6124,
	"./5S.png": 6591,
	"./6C.png": 5202,
	"./6D.png": 6765,
	"./6H.png": 7569,
	"./6S.png": 8418,
	"./7C.png": 2277,
	"./7D.png": 7610,
	"./7H.png": 6790,
	"./7S.png": 5093,
	"./8C.png": 9408,
	"./8D.png": 735,
	"./8H.png": 7747,
	"./8S.png": 8992,
	"./9C.png": 5227,
	"./9D.png": 3236,
	"./9H.png": 4040,
	"./9S.png": 3195,
	"./AC.png": 8035,
	"./AD.png": 8636,
	"./AH.png": 5088,
	"./AS.png": 7987,
	"./JC.png": 5774,
	"./JD.png": 1889,
	"./JH.png": 6973,
	"./JS.png": 6686,
	"./KC.png": 5281,
	"./KD.png": 4270,
	"./KH.png": 2466,
	"./KS.png": 9473,
	"./QC.png": 2099,
	"./QD.png": 8492,
	"./QH.png": 2240,
	"./QS.png": 5443,
	"./XX.png": 2435,
	"./back.png": 6978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9888;